import React from 'react';
import DefectsTable from '../components/defectsTable';

const OpenDefectDetails = ({ assetId, assetFleet, onBack }) => {
  return (
    <DefectsTable
      assetId={assetId}
      assetFleet={assetFleet}
      onBack={onBack}
      showBackButton
    />
  );
};

export default OpenDefectDetails;
